import { render, staticRenderFns } from "./cariaracomp.vue?vue&type=template&id=2bca5e51&scoped=true&"
import script from "./cariaracomp.vue?vue&type=script&lang=js&"
export * from "./cariaracomp.vue?vue&type=script&lang=js&"
import style0 from "./cariaracomp.vue?vue&type=style&index=0&id=2bca5e51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca5e51",
  null
  
)

export default component.exports